import { ActionButton, CommandButton, DefaultButton, Dialog, DialogFooter, DialogType, MessageBarType, PrimaryButton, Stack } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { PhotogalleryThumbnails } from '../../../Components/Photogallery/PhotogalleryThumbnails/PhotogalleryThumbnails';
import { IDictionary } from '../../../Models/IDictionary';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { IFolder } from '../../../Models/PhotoGallery/IFolder';
import { IImageThumbnail } from '../../../Models/PhotoGallery/IImageThumbnail';
import { IPhotoGalleryApi } from '../../../Services/API/PhotoGallery/IPhotoGalleryApi';
import { backendUrl } from '../../../Services/ConfigureService';
import * as Services from '../../../Services/Services';
import { AddImageView } from './AddImageView';
import { FolderPropertiosView } from './FolderProperties';

interface IPhotogalleryAdminListProps {

}

export const PhotogalleryAdminList: React.FC<IPhotogalleryAdminListProps> = props => {
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [thumbnails, setThumbnails] = React.useState<IImageThumbnail[]>([]);

    const [iconUrl, setIconUrl] = React.useState<any>();
    const [iconFile, setIconFile] = React.useState<File>();
    const [isAddOpen, setIsAddOpen] = useBoolean(false);
    const [isEditOpen, setIsEditOpen] = useBoolean(false);

    const [folder, setFolder] = React.useState<IFolder>();
    const [description, setDescription] = React.useState("");
    const [newFolderOpen, setNewFolderOpen] = useBoolean(false);
    const [selectedImages, setSelectedImage] = React.useState<IDictionary<IImageThumbnail>>({});
    const [isDeleteDialogOpened, setIsDeleteDialogOpened] = useBoolean(false);

    const loadThumbnails = async (f:IFolder) => {
        if (f) {
            setIsLoading.setTrue();
            setStatusMessage(undefined);
            const photogalleryApi = Services.ServicesProvider.GetService<IPhotoGalleryApi>(Services.PhotoGalleryApi);
            const thumbnails = await photogalleryApi.getImageThumbnails(f.id);
            if (thumbnails.isSuccess && thumbnails.data) {
                setThumbnails(thumbnails.data);
            }
            else {
                setStatusMessage({ message: thumbnails.message, type: MessageBarType.error });
            }
            setIsLoading.setFalse();
        }
    }

    const loadFolder = async (id?:number) => {
        const photogalleryApi = Services.ServicesProvider.GetService<IPhotoGalleryApi>(Services.PhotoGalleryApi);
        const folders = await photogalleryApi.getFolders(id);
        if (folders.isSuccess && folders.data) {
            loadThumbnails(folders.data);
            setFolder(folders.data);
            
        }
        else {
            setStatusMessage({ message: folders.message, type: MessageBarType.error });
        }
    }


    React.useEffect(() => {        
        loadFolder()
    }, [])

    const fileButtonClick = () => {
        if (document) {
            document.getElementById('hiddenFileInput')?.click();
        }
    }

    const onChanged = async (files: FileList) => {
        if (files) {
            const newaFiles: File[] = []
            if (files.length > 0) {
                setIconUrl(window.URL.createObjectURL(files[0]));
                setIconFile(files[0]);
            }
        }
    }

    const save = async () => {
        if (iconFile && folder) {
            const photogalleryApi = Services.ServicesProvider.GetService<IPhotoGalleryApi>(Services.PhotoGalleryApi);
            const result = await photogalleryApi.addImage(folder.id, iconFile, description);
            if (result.isSuccess && result.data) {
                setIconUrl(backendUrl() + `api/photogallery/GeImageById/${result.data}`);
                setIsAddOpen.setFalse();
                loadFolder();
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
        }
    }

    const saveDescription = async () => {
        const keys = Object.keys(selectedImages);
        if (keys.length === 1) {
            const photogalleryApi = Services.ServicesProvider.GetService<IPhotoGalleryApi>(Services.PhotoGalleryApi);
            const result = await photogalleryApi.editImageDescription(Number.parseInt(keys[0]), description);
            if (result.isSuccess && result.data) {
                setIconUrl(backendUrl() + `api/photogallery/GeImageById/${result.data}`);
                setIsAddOpen.setFalse();
                loadFolder();
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
        }
    }
    const saveFolder= async (id: number | undefined, name: string, parentId: number | undefined) => {
        if (name) {
            const photogalleryApi = Services.ServicesProvider.GetService<IPhotoGalleryApi>(Services.PhotoGalleryApi);
            const result = await photogalleryApi.createFolder(name,parentId);
            if (result.isSuccess && result.data) {
                setIconUrl(backendUrl() + `api/photogallery/GeImageById/${result.data}`);
                setNewFolderOpen.setFalse();
                loadFolder(result.data);
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
        }
    }

    const AddNewFoto = () => {
        setIconUrl(undefined);
        setIconFile(undefined);
        setDescription("");
        setIsAddOpen.setTrue();
    }

    const onSelectImage = (img: IImageThumbnail) => {
        var tmp = { ...selectedImages };
        if (!tmp[img.id]) {
            tmp[img.id] = img;
            setSelectedImage(tmp);
        }
        else {
            delete tmp[img.id];
            setSelectedImage(tmp);
        }
    }
    const EditFotoDescription = async () => {
        const keys = Object.keys(selectedImages);
        if (keys.length === 1) {
            const editImage = thumbnails.find(x => x.id = keys[0]);
            if (editImage) {
                setDescription(editImage.description ? editImage.description : "");
                setIsEditOpen.setTrue();
            }
        }
    }


    const deleteImages = async () => {
        const keys = Object.keys(selectedImages);
        if (keys.length>0) {
            const photogalleryApi = Services.ServicesProvider.GetService<IPhotoGalleryApi>(Services.PhotoGalleryApi);
            const result = await photogalleryApi.deleteImages(keys.map(x => Number.parseInt(x)));
            if (result.isSuccess && result.data) {
                setIconUrl(backendUrl() + `api/photogallery/GeImageById/${result.data}`);
                setIsDeleteDialogOpened.setFalse();
                loadFolder(folder?.id);
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
        }
    }

    return (<Stack>
        <Stack horizontal>
            <CommandButton iconProps={{ iconName: "Add" }} text="Přidej obrázek" onClick={AddNewFoto} />
            <CommandButton disabled={Object.keys(selectedImages).length !== 1} iconProps={{ iconName: "Edit" }} text="Uprav obrázek" onClick={EditFotoDescription} />
            <CommandButton iconProps={{ iconName: "FabricNewFolder" }} text="Vytvoř složku" onClick={setNewFolderOpen.setTrue} />
            <CommandButton disabled={Object.keys(selectedImages).length === 0} iconProps={{ iconName: "Delete" }} text="Odstraň" onClick={setIsDeleteDialogOpened.setTrue} />
        </Stack>
        <PhotogalleryThumbnails thumbnails={thumbnails} onSelect={onSelectImage} selected={selectedImages} />
        {isAddOpen ?
            <AddImageView save={save} onDismiss={setIsAddOpen.setFalse} fileButtonClick={fileButtonClick} iconUrl={iconUrl} onChanged={onChanged} description={description} setDescription={setDescription} />
            : null}
        {newFolderOpen ? <FolderPropertiosView parentId={folder?.id} onDismiss={setNewFolderOpen.setFalse} save={saveFolder} name="" id={undefined} /> : null}

        {isDeleteDialogOpened ?
            <Dialog
                hidden={!isDeleteDialogOpened}
                onDismiss={setIsDeleteDialogOpened.setFalse}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Odstranění',
                    closeButtonAriaLabel: 'Close',
                    subText: 'Opravdu chcete odstranit vybrané soubory?'
                }}

                modalProps={{ isBlocking: true, styles: { main: { maxWidth: 450 } } }}>
                <DialogFooter>
                    <Stack horizontal tokens={{ childrenGap:5 }}>
                        <PrimaryButton onClick={deleteImages} text="Odstranit" />
                        <DefaultButton onClick={setIsDeleteDialogOpened.setFalse} text="Zrušit" />
                    </Stack> 
                </DialogFooter>
            </Dialog>:null}
    </Stack>)
        
}